import React, { Component, createRef } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";
import { fetchFaqs } from "../../../actions/menuAction"
import FAQDetail from "./FAQDetail"
import { withRouter } from "react-router-dom"
class FAQ extends Component {
  constructor(props) {
    super(props);
    const { aboutProps } = this.props.location;
    const name = (aboutProps && aboutProps.name);

    this.state = {
      name
    };

  }

  componentDidMount() {
    const { fetchFaq } = this.props

    fetchFaq()
  }

  render() {

    const { faqs, location, dataSection } = this.props

    let dataFAQ = faqs.find(item => item.slug === location.pathname.replace("/helps/", ""))

    const subFAQ = dataFAQ && dataFAQ.faq

    return (
      <div id="helps-container">
        <p className="title-card">{dataFAQ.name}</p>
        {
          subFAQ && subFAQ.map((item, index) => (
            <FAQDetail item={item} subFaq={subFAQ} index={index} dataSection={dataSection} />
          ))
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dataSection: state.dataMenu.section_name,
  faqs: state.dataMenu.faqs.data
});

const mapDispathToProps = dispatch => ({
  fetchFaq: () => dispatch(fetchFaqs())
})

export default connect(mapStateToProps, mapDispathToProps)(withRouter(FAQ));
